// extracted by mini-css-extract-plugin
export default {"spinner":"Loading_spinner__Q+G8k","lds-roller":"Loading_lds-roller__2Zc5f"};